import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`} fill="none">
      <path
        d="M27.1201 11.1682C27.1201 11.1682 27.0301 8.00813 23.9901 4.83813C20.9501 1.67813 15.7301 1.57812 15.7301 1.57812H12.4701C12.4701 1.57812 7.25008 1.67813 4.21008 4.83813C1.17008 7.99813 1.08008 11.1682 1.08008 11.1682C1.08008 11.1682 5.25008 8.69812 6.30008 8.69812C7.32008 8.69812 9.66009 9.38818 14.0001 9.38818C18.3401 9.38818 20.8901 8.69812 21.9101 8.69812C22.9501 8.69812 27.1201 11.1682 27.1201 11.1682Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M12.6004 2.16821C12.6004 2.16821 11.9404 6.62811 11.9404 8.93811"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M11.4404 1.83813C11.4404 1.83813 8.96043 5.63815 9.13043 9.10815"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.63025 2.49805C8.63025 2.49805 5.00025 4.97799 4.01025 9.43799"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M15.5703 2.16821C15.5703 2.16821 16.2303 6.62811 16.2303 8.93811"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M16.7305 1.83813C16.7305 1.83813 19.2105 5.63815 19.0405 9.10815"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M19.5303 2.49805C19.5303 2.49805 23.1603 4.97799 24.1503 9.43799"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
